import React from "react";
import { Link, Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import MiniPlayer from "./MiniPlayer";
import ChatDrawer from "./ChatDrawer";
import NewsletterSignup from "./NewsletterSignup";
import InstallPWABanner from "./InstallPWABanner";
import { Toaster } from "sonner";

const Layout = () => {
  return (
    <div className="relative min-h-screen bg-jet grain">
      <Navbar />
      <main className="relative z-10 pt-28 md:pt-24 pb-32">
        <Outlet />
      </main>
      <footer className="relative z-10 border-t border-gold/15 mt-16">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-10 grid md:grid-cols-[1.2fr_1fr] gap-8">
          <div>
            <div className="font-display text-3xl text-gold-gradient">GFN SOUL NYC</div>
            <div className="font-body text-sm text-neutral-500 mt-1 mb-6">
              Two stations. One live TV network. Round-the-clock soul.
            </div>
            <div className="flex items-center flex-wrap gap-4 font-condensed uppercase tracking-widest text-[11px] text-neutral-400">
              <a href="https://www.instagram.com/djwayneg151/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="hover:text-gold transition-colors">Instagram</a>
              <a href="https://www.facebook.com/suprememasterdjwayneg/" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="hover:text-gold transition-colors">Facebook</a>
              <a href="https://www.youtube.com/@gfnsoulnycfm" target="_blank" rel="noopener noreferrer" data-testid="footer-youtube" className="hover:text-gold transition-colors">YouTube</a>
              <a href="https://www.tiktok.com/@gfnsoulnyc" target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok" className="hover:text-gold transition-colors">TikTok</a>
              <Link to="/contact" data-testid="footer-contact" className="hover:text-gold transition-colors">Contact</Link>
            </div>
          </div>
          <NewsletterSignup />
        </div>
        <div className="text-center text-[10px] font-condensed uppercase tracking-[0.35em] text-neutral-600 pb-6">
          © {new Date().getFullYear()} GFN Soul NYC — Broadcast Network
        </div>
      </footer>
      <MiniPlayer />
      <ChatDrawer />
      <InstallPWABanner />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
};

export default Layout;
